import { AbstractSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import { SymbolSubcomponent } from "../symbol-subcomponent";

export class AlphaDimSymbolBehaviour extends AbstractSymbolBehaviour {

    public behaviourName: string = "AlphaDim";

    constructor(symbol: SymbolSubcomponent, protected dimAlpha: number = 0.5) {
        super(symbol);
    }

    public static() {
        super.static();
        this.symbol.setAlpha(1);
    }

    public winDim() {
        this.symbol.setAlpha(this.dimAlpha);
        return super.winDim();
    }

    public cycleDim() {
        this.symbol.setAlpha(this.dimAlpha);
        return super.cycleDim();
    }

    public highlightDim() {
        this.symbol.setAlpha(this.dimAlpha);
        return super.highlightDim();
    }
}
